module.exports = __webpack_public_path__ + "static/media/NO.fc8ae19c.svg";